// extracted by css-extract-rspack-plugin
export default {"container":"container-aiaqk5","fullHeight":"fullHeight-jshWCR","refresh":"refresh-DXIn4E","list":"list-Wq10AO","detail":"detail-QOaKS2"};